export default __webpack_public_path__ + "static/media/request-selected.ab9c785f.png";